
























import { Component, Prop, Vue } from 'vue-property-decorator'
import Route, { nextPage, prevPage } from '@/routes'
import * as t from '@/types'
import steps from '@/steps'
import { Mutation, Getter } from 'vuex-class'

import { ArcDefinition, drawArc } from '@/drawArc'

@Component
export default class Navigation extends Vue {
  @Prop() private currentStep!: t.StepDefinition
  @Getter private isStepCompleted!: (step: t.StepDefinition) => boolean
  @Getter private stepReached!: number
  @Getter private endReached!: boolean
  private steps: t.StepDefinition[] = Object.values(steps)

  get stepIndex () {
    let i = 1
    for (const s of this.steps) {
      if (this.currentStep && s.link === this.currentStep.link) {
        return i
      }
      i += 1
    }
    return 0
  }

  get nextLabel () {
    switch (this.currentStep.name) {
      case steps.step1.name:
        return steps.step2.name
      case steps.step2.name:
        return steps.step3.name
      case steps.step3.name:
        return steps.step4.name
      case steps.step4.name:
        return steps.step5.name
      case steps.step5.name:
        return steps.step6.name
      case steps.step6.name:
        return steps.step7.name
      case steps.step7.name:
      default:
        return 'Report'
    }
  }

  get nextPage () {
    return nextPage(this.currentStep.link)
  }
  prevPage () {
    return prevPage(this.$router.currentRoute.name as Route)
  }


  stepClasses (step: t.StepDefinition) {
    const classes: string[] = []
    if (!this.currentStep) {
      return classes
    }
    if (step.name === this.currentStep.name) {
      classes.push('step-current')
      if (this.endReached) {
        classes.push('step-edit')
      }
    }
    if (this.isStepCompleted(step)) {
      classes.push('step-done')
    }

    return classes
  }

  get paths () {
    const input = this.stepIndex
    const total = 7
    const angle = 360 * (input / total)
    const arcs = [
      drawArc({
        radius: 30,
        thickness: 6,
        start_angle: 180,
        end_angle: 360,
        opacity: 1,
      }),
      drawArc({
        radius: 30,
        thickness: 6,
        start_angle: 0,
        end_angle: 180,
        opacity: 1,
      }),
      drawArc({
        radius: 30,
        thickness: 6,
        start_angle: 0,
        end_angle: angle - 0.001,
        opacity: 1,
      }),
    ]

    return arcs
  }
}
